import { ErrorCode } from '@aeon-karaoke/shared/generic/enum/ErrorCode';
import type { IErrorState } from '@aeon-karaoke/shared/generic/interface/error/IErrorState';

export abstract class AppError extends Error {
  abstract readonly code: ErrorCode;
  abstract readonly statusCode: number;
  readonly timestamp = new Date();
  readonly correlationId?: string;

  constructor(message: string, correlationId?: string) {
    super(message);
    this.name = this.constructor.name;
    this.correlationId = correlationId;
    Error.captureStackTrace(this, this.constructor);
  }

  toJSON(): IErrorState {
    return {
      code: this.code,
      message: this.message,
      correlationId: this.correlationId,
      timestamp: this.timestamp.toISOString(),
    };
  }
}
